import { Activity } from '../models/activity';
import { GetEmployeeActivities } from '../services/api/employeeServices';
import { useGetActivitiesQuery } from '../store/activities/activitiesService';

interface UseActivitiesReturn {
  activities: Activity[];
  isLoading: boolean;
  isFetching: boolean;
  activitiesIsError: boolean;
  activitiesError: unknown;
  refetch: () => void;
}

export const useActivities = (
  args: GetEmployeeActivities
): UseActivitiesReturn => {
  const {
    data,
    isLoading,
    isFetching,
    refetch,
    isError: activitiesIsError,
    error: activitiesError,
  } = useGetActivitiesQuery(args);

  const activities = data || ([] as Activity[]);

  return {
    activities,
    isLoading,
    isFetching,
    activitiesIsError,
    refetch,
    activitiesError,
  };
};
